import { Link, useParams } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';

const NutrareProductDetailPage = () => {
  const { id } = useParams();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [id]);

  const products = [
    {
      id: 1,
      name: 'Achocolatado',
      weight: '1,01 kg',
      category: 'Achocolatado',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/2e148fef00e43df5e320940e473e687c.png',
      description: 'Alimento achocolatado em pó de alta qualidade.',
      yield: '60 porções de 200ml',
      flavor: 'Chocolate',
      usage: 'Para enriquecer o leite ou como ingredientes em diversas aplicações',
      preparation: [
        'Dissolva o conteúdo da embalagem (1,01 kg) em 11 litros de leite gelado ou quente e misture bem até completa dissolução',
        'Para cada copo de 200 ml de leite, misture 2 colheres de sopa de Achocolatado',
        'Conservar em local seco e fresco. Após aberto, consumir em até 30 dias'
      ],
      nutritionalInfo: {
        portion: '20 g (2 colheres de sopa)',
        calories: '78 kcal',
        carbs: '18 g',
        protein: '0 g',
        fat: '0 g',
        fiber: '0 g'
      },
      ingredients: 'Açúcar, cacau em pó, maltodextrina, sal, aromatizante, vitaminas e minerais',
      allergens: 'PODE CONTER TRIGO, AVEIA, CEVADA, CENTEIO, SOJA, LEITE E OVOS',
      storage: 'Conservar em local seco e fresco. Após aberto, consumir em até 30 dias'
    },
    {
      id: 2,
      name: 'Bebida láctea',
      weight: '1 kg',
      category: 'Bebida',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/6c6bc8a30118df848debcc8655fca8de.png',
      description: 'Mistura para o preparo de bebida sabor chocolate com vitaminas, ferro quelato (ferro de alta absorção) e zinco.',
      yield: '23 porções de 200ml',
      flavor: 'Chocolate',
      usage: 'Bebida pronta para o consumo',
      preparation: [
        'Dissolva cada 1 kg do produto em 4 litros de água fria, gelada ou morna',
        'Mexa até a completa dissolução',
        'Conservar em local seco e fresco. Após aberto, consumir em até 30 dias respeitando a validade'
      ],
      nutritionalInfo: {
        portion: '43g (4 colheres de sopa)',
        calories: '172kcal',
        carbs: '36g',
        protein: '2g',
        fat: '1,7g',
        fiber: '0,7g'
      },
      ingredients: 'Açúcar, leite em pó, soro de leite em pó, gordura vegetal, maltodextrina, amido modificado, cacau em pó, farinha micronizada de soja (Agrobacterium tumefaciens), sal, mistura de vitaminas e sais minerais (A, C, B1, B6, B3, Ferro quelato e Zinco), emulsificantes: lecitina de soja e glicerina, espessante goma guar e aroma sintético idêntico ao natural de baunilha',
      allergens: 'CONTÉM LEITE E DERIVADOS E DERIVADOS DE SOJA. PODE CONTER TRIGO, AVEIA, CEVADA CENTEIO E OVO. CONTÉM LACTOSE. CONTÉM GLÚTEN',
      storage: 'Conservar em local seco e fresco. Após aberto, consumir em até 30 dias respeitando a validade. Contém aromatizante sintético idêntico ao natural'
    },
    {
      id: 3,
      name: 'Caldo Galinha',
      weight: '1kg',
      category: 'Caldo',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/00891f213e9dd39c820fc8627d8898ce.png',
      description: 'Caldo de galinha, preparo para caldo sabor galinha.',
      yield: '50 litros',
      flavor: 'Galinha',
      usage: 'Sopas, caldos e temperos',
      preparation: [
        'Dissolva o conteúdo do pacote  em 50 litros de água fervente',
        'Mexa bem até dissolver completamente',
        'Utilize como base para sopas ou tempero'
      ],
      nutritionalInfo: {
        portion: '4.75g (1 tablete)',
        calories: '10kcal',
        carbs: '1g',
        protein: '0.5g',
        fat: '0.5g',
        fiber: '0g'
      }
    },
    {
      id: 14,
      name: 'Caldo Carne',
      weight: '1kg',
      category: 'Caldo',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/e40a27dd54285e3d6ca4a34f99955b9f.png',
      description: 'Caldo de carne, preparo para caldo sabor carne.',
      yield: '50 litros',
      flavor: 'Carne',
      usage: 'Sopas, caldos e temperos',
      preparation: [
        'Dissolva o conteúdo do pacote em 50 litros de água fervente',
        'Mexa bem até dissolver completamente',
        'Utilize como base para sopas ou tempero'
      ]
    },
    {
      id: 4,
      name: 'Gelatina Uva',
      weight: '1 Kg',
      category: 'Gelatina',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/0aea70a1482976e30d89f198c893e43b.png',
      description: 'Gelatina em pó sabor uva, prática e deliciosa para grandes volumes.',
      yield: '55 porções de 120g',
      flavor: 'Uva',
      usage: 'Sobremesas',
      preparation: [
        'Aqueça 500ml de água e adicione 100g do produto lentamente',
        'Mexa até a dissolução completa',
        'Acrescente mais 500ml de água fria, despeje em formas e leve à geladeira até adquirir consistência'
      ],
      nutritionalInfo: {
        portion: '18g Porção',
        calories: '58kcal',
        carbs: '14g',
        protein: '0g',
        fat: '0g',
        fiber: '0g'
      }
    },
    {
      id: 5,
      name: 'Mingau',
      weight: '1 kg',
      category: 'Mingau',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/e3a6a795b5cc7433a7b1da36ad155f9f.png',
      description: 'Mistura para o preparo de mingau sabor tapioca com coco com vitaminas, ferro e zinco.',
      yield: '42 porções de 120g de mingau pronto para o consumo',
      flavor: 'Tapioca com Coco',
      usage: 'Café da manhã',
      preparation: [
        'Despeje o pacote de 1 kg do produto em 2 Litros de água fria e misture bem',
        'Acrescente 2 litros de água quente e leve ao fogo',
        'Após iniciar a fervura, cozinhe em fogo brando por 2 minutos, mexendo sempre'
      ],
      nutritionalInfo: {
        portion: '24g (3 colheres de sopa)',
        calories: '96 kcal',
        carbs: '21 g',
        protein: '0,7 g',
        fat: '1 g',
        fiber: '0 g'
      },
      ingredients: 'Açúcar, amido de milho (Bacillus thuringiensis e/ou Agrobacterium tumefaciens e/ou Streptomyces viridochrmogenes e/ou Zea mays), leite em pó, soro de leite em pó, gordura vegetal, tapioca, farinha micronizada de soja (Agrobacterium tumefaciens), maltodextrina, sal, mistura de vitaminas e sais minerais (Vitaminas A, B1, B6, C, B3, Ferro e Zinco), emulsificante glicerina e aroma sintético idêntico ao natural de coco',
      allergens: 'ALÉRGICOS: CONTÉM LEITE E DERIVADOS E DERIVADOS DE SOJA. PODE CONTER TRIGO, AVEIA, CEVADA, CENTEIO E OVO. CONTÉM LACTOSE. CONTÉM GLÚTEN',
      storage: 'Conservar em local seco e fresco. Após aberto, consumir em até 30 dias respeitando a validade. Contém aromatizante sintético idêntico ao natural'
    },
    {
      id: 6,
      name: 'Purê de Batata',
      weight: '150g',
      category: 'Purê',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/d99f6e0bcbc4e5ec02098257ac53950a.png',
      description: 'Purê de batata instantâneo, cremoso e saboroso, pronto em minutos.',
      yield: '6 porções de 100g',
      flavor: 'Batata',
      usage: 'Acompanhamento',
      preparation: [
        'Ferva 200ml de água com sal a gosto',
        'Adicione 25g do produto e mexa vigorosamente',
        'Deixe descansar por 1 minuto e sirva'
      ],
      nutritionalInfo: {
        portion: '25g',
        calories: '85kcal',
        carbs: '18g',
        protein: '2g',
        fat: '0.5g',
        fiber: '1g'
      }
    },
    {
      id: 7,
      name: 'Risoto sabor frango',
      weight: '1 kg',
      category: 'Risoto',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/47c684e1faa583cd7fd54b57ef7e9150.png',
      description: 'Mistura para o preparo de risoto sabor frango (arroz à grega).',
      yield: 'Aprox. 20 porções de 250g de risoto pronto para consumo',
      flavor: 'Frango',
      usage: 'Prato principal',
      preparation: [
        'Despeje 1 kg do produto em 4 Litros de água quente e mexa até o ferver',
        'Depois cozinhe em fogo brando por cerca de 20 a 25 minutos'
      ],
      nutritionalInfo: {
        portion: '50g (¼ de xícara)',
        calories: '168kcal',
        carbs: '37g',
        protein: '4g',
        fat: '0g',
        fiber: '0g'
      },
      ingredients: 'Arroz parboilizado, proteína texturizada de soja (Agrobacterium sp), sal, amido de milho (Bacillus thuringiensis e/ou Agrobacterium tumefaciens e/ou Streptomyces viridochrmogenes e/ou Zea mays), cenoura desidratada, mandioquinha em cubos, cúrcuma, salsa em flocos, colorífico, emulsificante glicerina, antiumectante fosfato tricálcico, aromatizantes e realçadores de sabor: glutamato monossódico e inosinato de sódio',
      allergens: 'ALÉRGICOS: CONTÉM DERIVADOS DE SOJA. PODE CONTER TRIGO, AVEIA, CEVADA, CENTEIO, LEITE E OVO. CONTÉM GLÚTEN',
      storage: 'Conservar em local seco e fresco. Após aberto, consumir em até 30 dias respeitando a validade. Contém aromatizante sintético idêntico ao natural'
    },
    {
      id: 15,
      name: 'Risoto sabor carne',
      weight: '1 kg',
      category: 'Risoto',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8b45d35261430a4858486f66ad4d9487.png',
      description: 'Mistura para o preparo de risoto sabor carne (arroz à grega).',
      yield: 'Aprox. 20 porções de 250g de risoto pronto para consumo',
      flavor: 'Carne',
      usage: 'Prato principal',
      preparation: [
        'Despeje 1 kg do produto em 4 Litros de água quente e mexa até o ferver',
        'Depois cozinhe em fogo brando por cerca de 20 a 25 minutos'
      ],
      nutritionalInfo: {
        portion: '50g (¼ de xícara)',
        calories: '168kcal',
        carbs: '37g',
        protein: '2g',
        fat: '0g',
        fiber: '1g'
      },
      ingredients: 'Arroz parbolizado, proteína texturizada de soja (Agrobacterium sp), sal, amido de milho (Bacillus thuringiensis e/ou Agrobacterium tumefaciens e/ou Streptomyces viridochrmogenes e/ou Zea mays), cenoura desidratada, mandioquinha em cubos, salsa em flocos, colorífico, pimenta, emulsificante glicerina, antiumectante fosfato tricálcico, aromatizantes, realçadores de sabor: glutamato monossódico e inosinato de sódio e corante caramelo IV 150d',
      allergens: 'ALÉRGICOS: CONTÉM DERIVADOS DE SOJA. PODE CONTER TRIGO, AVEIA, CEVADA, CENTEIO, LEITE E OVO. CONTÉM GLÚTEN',
      storage: 'Conservar em local seco e fresco. Após aberto, consumir em até 30 dias respeitando a validade. Contém aromatizante sintético idêntico ao natural'
    },
    {
      id: 8,
      name: 'Sopa de macarrão sabor frango',
      weight: '68g',
      category: 'Sopa',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/93147c46b10d99b8b9618608be6425e3.png',
      description: 'Sopa de legumes instantânea, nutritiva e reconfortante para qualquer momento do dia.',
      yield: '4 porções de 200ml',
      flavor: 'Legumes',
      usage: 'Refeição rápida',
      preparation: [
        'Dissolva o conteúdo do pacote em 800ml de água fervente',
        'Mexa bem e deixe cozinhar por 3 minutos',
        'Sirva quente'
      ],
      nutritionalInfo: {
        portion: '17g',
        calories: '60kcal',
        carbs: '12g',
        protein: '2g',
        fat: '0.5g',
        fiber: '1.5g'
      }
    },
    {
      id: 9,
      name: 'Sopa de macarrão sabor carne',
      weight: '68g',
      category: 'Sopa',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/de4da2c3ada18bfca1fc87ffd1228283.png',
      description: 'Sopa de cebola instantânea, sabor marcante e tradicional, pronta em minutos.',
      yield: '4 porções de 200ml',
      flavor: 'Cebola',
      usage: 'Refeição rápida',
      preparation: [
        'Dissolva o conteúdo do pacote em 800ml de água fervente',
        'Mexa bem e deixe cozinhar por 3 minutos',
        'Sirva quente com croutons'
      ],
      nutritionalInfo: {
        portion: '17g',
        calories: '55kcal',
        carbs: '11g',
        protein: '1.5g',
        fat: '0.5g',
        fiber: '1g'
      }
    },
    {
      id: 10,
      name: 'Gelatina Morango',
      weight: '1 Kg',
      category: 'Gelatina',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/e61f34019691789ee4275c3adc73bd4e.png',
      description: 'Gelatina em pó sabor morango, prática e deliciosa para grandes volumes.',
      yield: '55 porções de 120g',
      flavor: 'Morango',
      usage: 'Sobremesas',
      preparation: [
        'Aqueça 500ml de água e adicione 100g do produto lentamente',
        'Mexa até a dissolução completa',
        'Acrescente mais 500ml de água fria, despeje em formas e leve à geladeira até adquirir consistência'
      ],
      nutritionalInfo: {
        portion: '18g Porção',
        calories: '58kcal',
        carbs: '14g',
        protein: '0g',
        fat: '0g',
        fiber: '0g'
      }
    },
    {
      id: 11,
      name: 'Gelatina Framboesa',
      weight: '1 Kg',
      category: 'Gelatina',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/8237220725243656e6aea2d36901ccd4.png',
      description: 'Gelatina em pó sabor framboesa, prática e deliciosa para grandes volumes.',
      yield: '55 porções de 120g',
      flavor: 'Framboesa',
      usage: 'Sobremesas',
      preparation: [
        'Aqueça 500ml de água e adicione 100g do produto lentamente',
        'Mexa até a dissolução completa',
        'Acrescente mais 500ml de água fria, despeje em formas e leve à geladeira até adquirir consistência'
      ],
      nutritionalInfo: {
        portion: '18g Porção',
        calories: '58kcal',
        carbs: '14g',
        protein: '0g',
        fat: '0g',
        fiber: '0g'
      }
    },
    {
      id: 12,
      name: 'Gelatina Limão',
      weight: '1 Kg',
      category: 'Gelatina',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/3e2adb7d0084ebf66f8bf720427302fe.png',
      description: 'Gelatina em pó sabor limão, prática e deliciosa para grandes volumes.',
      yield: '55 porções de 120g',
      flavor: 'Limão',
      usage: 'Sobremesas',
      preparation: [
        'Aqueça 500ml de água e adicione 100g do produto lentamente',
        'Mexa até a dissolução completa',
        'Acrescente mais 500ml de água fria, despeje em formas e leve à geladeira até adquirir consistência'
      ],
      nutritionalInfo: {
        portion: '18g Porção',
        calories: '58kcal',
        carbs: '14g',
        protein: '0g',
        fat: '0g',
        fiber: '0g'
      }
    },
    {
      id: 13,
      name: 'Gelatina Abacaxi',
      weight: '1 Kg',
      category: 'Gelatina',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/551ff55d4cdef2eeb2a2fa364af6733e.png',
      description: 'Gelatina em pó sabor abacaxi, prática e deliciosa para grandes volumes.',
      yield: '55 porções de 120g',
      flavor: 'Abacaxi',
      usage: 'Sobremesas',
      preparation: [
        'Aqueça 500ml de água e adicione 100g do produto lentamente',
        'Mexa até a dissolução completa',
        'Acrescente mais 500ml de água fria, despeje em formas e leve à geladeira até adquirir consistência'
      ],
      nutritionalInfo: {
        portion: '18g Porção',
        calories: '58kcal',
        carbs: '14g',
        protein: '0g',
        fat: '0g',
        fiber: '0g'
      }
    }
  ];

  const product = products.find(p => p.id === Number(id));

  if (!product) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Produto não encontrado</h2>
          <Link to="/nutrare" className="text-orange-600 hover:text-orange-700 font-semibold">
            Voltar para produtos
          </Link>
        </div>
      </div>
    );
  }

  // Se for um produto de gelatina, mostrar todos os sabores
  const isGelatinCategory = product.category === 'Gelatina';
  const allGelatinProducts = products.filter(p => p.category === 'Gelatina');

  // Se for um produto de risoto, mostrar todos os sabores
  const isRisotoCategory = product.category === 'Risoto';
  const allRisotoProducts = products.filter(p => p.category === 'Risoto');

  // Componente para renderizar um produto individual
  const ProductCard = ({ productData }) => (
    <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        {/* Product Image */}
        <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-8">
          <div className="aspect-square w-full h-full flex items-center justify-center">
            <img 
              src={productData.image}
              alt={productData.name}
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        {/* Product Info */}
        <div className="flex flex-col justify-center p-8 lg:p-12">
          <div className="mb-6">
            <span className="inline-block px-4 py-2 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-semibold rounded-full mb-4">
              {productData.category}
            </span>
            <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              {productData.name}
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              {productData.description}
            </p>
          </div>

          {/* Product Specifications */}
          <div className="bg-gray-50 rounded-xl p-6 mb-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Especificações</h3>
            <div className="space-y-3">
              <div className="flex items-center justify-between py-2 border-b border-gray-200">
                <span className="text-gray-600 font-medium">Rendimento:</span>
                <span className="text-gray-900 font-semibold">{productData.yield}</span>
              </div>
              <div className="flex items-center justify-between py-2 border-b border-gray-200">
                <span className="text-gray-600 font-medium">Peso:</span>
                <span className="text-gray-900 font-semibold">{productData.weight}</span>
              </div>
              <div className="flex items-center justify-between py-2 border-b border-gray-200">
                <span className="text-gray-600 font-medium">Sabor:</span>
                <span className="text-gray-900 font-semibold">{productData.flavor}</span>
              </div>
              <div className="flex items-center justify-between py-2">
                <span className="text-gray-600 font-medium">Onde usar:</span>
                <span className="text-gray-900 font-semibold">{productData.usage}</span>
              </div>
            </div>
          </div>

          {/* Nutritional Info */}
          {productData.nutritionalInfo && (
            <div className="bg-orange-50 rounded-xl p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">Informação Nutricional</h3>
              <div className="text-sm text-gray-600 mb-2">Por porção: {productData.nutritionalInfo.portion}</div>
              <div className="grid grid-cols-2 gap-3">
                <div className="flex justify-between">
                  <span className="text-gray-600">Calorias:</span>
                  <span className="font-semibold">{productData.nutritionalInfo.calories}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Carboidratos:</span>
                  <span className="font-semibold">{productData.nutritionalInfo.carbs}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Proteínas:</span>
                  <span className="font-semibold">{productData.nutritionalInfo.protein}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Gorduras:</span>
                  <span className="font-semibold">{productData.nutritionalInfo.fat}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Preparation Instructions */}
      <div className="p-8 lg:p-12 border-t border-gray-100">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-amber-500 rounded-full flex items-center justify-center">
            <i className="ri-file-list-3-line text-white text-xl"></i>
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Modo de Preparo</h2>
        </div>
        <div className="space-y-4">
          {productData.preparation.map((step, index) => (
            <div key={index} className="flex gap-4">
              <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-r from-orange-500 to-amber-500 text-white rounded-full flex items-center justify-center font-bold text-sm">
                {index + 1}
              </div>
              <p className="text-gray-700 leading-relaxed pt-1">
                {step}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-amber-50 pt-20">
      {/* Breadcrumb */}
      <div className="bg-white border-b shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center gap-2 text-sm">
            <Link to="/" className="text-gray-500 hover:text-orange-600 transition-colors">
              Início
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <Link to="/nutrare" className="text-gray-500 hover:text-orange-600 transition-colors">
              Nutrare
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900 font-medium">{product.category}</span>
          </div>
        </div>
      </div>

      {/* Products Section */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4">
          {isGelatinCategory ? (
            <>
              {/* Header for Gelatin Category */}
              <div className="text-center mb-16">
                <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
                  Linha Completa de Gelatinas Nutrare
                </h1>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                  Descubra todos os sabores disponíveis da nossa linha de gelatinas em pó, 
                  práticas e deliciosas para grandes volumes.
                </p>
              </div>

              {/* All Gelatin Products */}
              {allGelatinProducts.map((gelatinProduct, index) => (
                <ProductCard key={gelatinProduct.id} productData={gelatinProduct} />
              ))}
            </>
          ) : isRisotoCategory ? (
            <>
              {/* Header for Risoto Category */}
              <div className="text-center mb-16">
                <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
                  Linha Completa de Risotos Nutrare
                </h1>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                  Descubra todos os sabores disponíveis da nossa linha de risotos, 
                  práticos e deliciosos para refeições especiais.
                </p>
              </div>

              {/* All Risoto Products */}
              {allRisotoProducts.map((risotoProduct, index) => (
                <ProductCard key={risotoProduct.id} productData={risotoProduct} />
              ))}
            </>
          ) : (
            /* Single Product Display for Other Categories */
            <ProductCard productData={product} />
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-orange-500 via-amber-500 to-orange-600">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Qualidade Nutrare em Cada Produto
          </h2>
          <p className="text-xl text-white/95 mb-8 leading-relaxed">
            Descubra nossa linha completa de produtos essenciais para sua cozinha
          </p>
          <a 
            href="https://wa.me/5519998928137"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 bg-white text-orange-600 font-semibold rounded-full hover:bg-orange-50 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            Entre em Contato
            <i className="ri-arrow-right-line ml-2 text-xl"></i>
          </a>
        </div>
      </section>
    </div>
  );
};

export default NutrareProductDetailPage;
